import { gql } from "@apollo/client";

export const getLeaderboardsList = gql`
  query ListLeaderboards(
    $page: Int
    $size: Int
    $leaderboardStatus: LeaderboardStatus
    $title: String
    $startsAt: OffsetDateTime
    $endsAt: OffsetDateTime
  ) {
    listLeaderboards(
      page: $page
      size: $size
      leaderboardStatus: $leaderboardStatus
      title: $title
      startsAt: $startsAt
      endsAt: $endsAt
    ) {
      totalCount
      items {
        id
        programId
        title
        startsAt
        endsAt
        leaderboardStatus
        rankOrder
        tieBreaker
        scoringMode
        activePointMinimum
        minParticipationCount
        awardApproval
        createdAt
        updatedAt
        rewardsStatus
      }
    }
  }
`;

export const getLeaderboardById = gql`
  query GetLeaderboard($id: ID!) {
    getLeaderboard(id: $id) {
      id
      programId
      title
      startsAt
      endsAt
      leaderboardStatus
      rankOrder
      tieBreaker
      scoringMode
      activePointMinimum
      minParticipationCount
      awardApproval
      createdAt
      updatedAt
      rewardsStatus
    }
  }
`;

export const listLeaderboardEntries = gql`
  query ListLeaderboardEntries($id: ID!, $page: Int, $size: Int) {
    listLeaderboardEntries(leaderboardId: $id, page: $page, size: $size) {
      totalCount
      items {
        id
        leaderboardId
        profileId
        profile {
          id
          userInfo {
            firstName
            lastName
            gender
            profilePic
            emailAddress
            phone
            birthDate
          }
          contact {
            addresses {
              street
              streetTwo
              city
              stateProvince
              country
              postalCode
            }
          }
        }
        reward {
          id
          name
        }
        points
        entryRank
        rewardRank
        entryStatus
        createdAt
        updatedAt
      }
    }
  }
`;
export const listLeaderboardRankedEntries = gql`
  query ListLeaderboardRankedEntries($id: ID!, $page: Int, $size: Int) {
    listLeaderboardRankedEntries(leaderboardId: $id, page: $page, size: $size) {
      totalCount
      items {
        id
        leaderboardId
        profileId
        profile {
          id
          userInfo {
            firstName
            lastName
            gender
            profilePic
            emailAddress
            phone
            birthDate
          }
          contact {
            addresses {
              street
              streetTwo
              city
              stateProvince
              country
              postalCode
            }
          }
        }
        reward {
          id
          name
        }
        points
        entryRank
        rewardRank
        entryStatus
        createdAt
        updatedAt
      }
    }
  }
`;
export const listLeaderboardRemovedEntries = gql`
  query ListLeaderboardRemovedEntries($id: ID!, $page: Int, $size: Int) {
    listLeaderboardRemovedEntries(leaderboardId: $id, page: $page, size: $size) {
      totalCount
      items {
        id
        leaderboardId
        profileId
        profile {
          id
          userInfo {
            firstName
            lastName
            gender
            profilePic
            emailAddress
            phone
            birthDate
          }
          contact {
            addresses {
              street
              streetTwo
              city
              stateProvince
              country
              postalCode
            }
          }
        }
        reward {
          id
          name
        }
        points
        entryRank
        rewardRank
        entryStatus
        createdAt
        updatedAt
      }
    }
  }
`;
export const listLeaderboardUnrankedEntries = gql`
  query ListLeaderboardUnrankedEntries($id: ID!, $page: Int, $size: Int) {
    listLeaderboardUnrankedEntries(leaderboardId: $id, page: $page, size: $size) {
      totalCount
      items {
        id
        leaderboardId
        profileId
        profile {
          id
          userInfo {
            firstName
            lastName
            gender
            profilePic
            emailAddress
            phone
            birthDate
          }
          contact {
            addresses {
              street
              streetTwo
              city
              stateProvince
              country
              postalCode
            }
          }
        }
        reward {
          id
          name
        }
        points
        entryRank
        rewardRank
        entryStatus
        createdAt
        updatedAt
      }
    }
  }
`;
